var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", staticClass: "form", attrs: { tag: "form" } },
    [
      _c(
        "el-row",
        [
          _c("divider", {
            staticClass: "text-container",
            attrs: { label: "Cadastro de documentos" }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "container-cadastro" },
        [
          _c(
            "el-row",
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "documento" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Upload do documento:",
                            required: true
                          }
                        }),
                        _c("app-upload-area", {
                          attrs: {
                            id: "documento",
                            target: _vm.urlUpload,
                            fileType: _vm.validExtensions,
                            onSuccess: _vm.onSuccess,
                            documento: _vm.documento,
                            errors: errors,
                            onError: _vm.onError
                          },
                          on: {
                            download: _vm.downloadDocumento,
                            removerDocumento: _vm.removerDocumento
                          },
                          model: {
                            value: _vm.documento,
                            callback: function($$v) {
                              _vm.documento = $$v
                            },
                            expression: "documento"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required", name: "Nome" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: {
                                label: "Nome do documento:",
                                required: true
                              }
                            }),
                            _c("el-input", {
                              staticClass: "input",
                              class: { erro: errors.length },
                              model: {
                                value: _vm.documentoAssinatura.nome,
                                callback: function($$v) {
                                  _vm.$set(_vm.documentoAssinatura, "nome", $$v)
                                },
                                expression: "documentoAssinatura.nome"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: {
                                label: "Tipo do documento:",
                                required: true
                              }
                            }),
                            _c(
                              "el-select",
                              {
                                staticClass: "input select",
                                class: { erro: errors.length },
                                attrs: {
                                  filterable: "filterable",
                                  "filter-method": _vm.filtrarTipoDocumento,
                                  placeholder: "Selecione",
                                  "value-key": "id",
                                  name: "Tipo"
                                },
                                nativeOn: {
                                  paste: function($event) {
                                    return _vm.onPaste($event)
                                  }
                                },
                                model: {
                                  value: _vm.documentoAssinatura.tipo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.documentoAssinatura,
                                      "tipo",
                                      $$v
                                    )
                                  },
                                  expression: "documentoAssinatura.tipo"
                                }
                              },
                              _vm._l(_vm.tiposDocumentoFiltrados, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.nome, value: item }
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: {
                                label: "Responsável(eis):",
                                required: true
                              }
                            }),
                            _c(
                              "el-select",
                              {
                                staticClass: "input select",
                                class: { erro: errors.length },
                                attrs: {
                                  filterable: "filterable",
                                  "filter-method": _vm.filtrarResponsaveis,
                                  multiple: "multiple",
                                  "collapse-tags": "collapse-tags",
                                  placeholder: "Selecione",
                                  "value-key": "id",
                                  name: "Resposavel"
                                },
                                nativeOn: {
                                  paste: function($event) {
                                    return _vm.onPaste($event)
                                  }
                                },
                                model: {
                                  value: _vm.documentoAssinatura.responsaveis,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.documentoAssinatura,
                                      "responsaveis",
                                      $$v
                                    )
                                  },
                                  expression: "documentoAssinatura.responsaveis"
                                }
                              },
                              _vm._l(_vm.responsaveisFiltrados, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.usuario.pessoa.nomeRazaoSocial,
                                    value: item
                                  }
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-buttons-cadastro", {
        attrs: { isPrimeiroPasso: true, isUltimoPasso: true },
        on: { cancelar: _vm.cancelar, finalizar: _vm.finalizar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9be2a150", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9be2a150","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/assinatura/CadastroDocumento.vue
// module id = null
// module chunks = 